const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    className="lucide lucide-circle-x-icon lucide-circle-x"
    version="1.1"
    viewBox="0 0 26.4 26.4"
  >
    <path
      fill={color}
      stroke="none"
      d="M13.2 0C5.922 0 0 5.923 0 13.2c0 7.275 5.923 13.2 13.2 13.2 7.275 0 13.2-5.925 13.2-13.2C26.4 5.922 20.475 0 13.2 0m0 2.4C19.177 2.4 24 7.22 24 13.2 24 19.177 19.178 24 13.2 24A10.78 10.78 0 0 1 2.4 13.2 10.78 10.78 0 0 1 13.2 2.4"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      d="M16.8 8.4a1.2 1.2 0 0 0-.849.352l-7.199 7.2a1.2 1.2 0 0 0 0 1.696 1.2 1.2 0 0 0 1.697 0l7.2-7.199a1.2 1.2 0 0 0 0-1.697A1.2 1.2 0 0 0 16.8 8.4"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      d="M9.6 8.4a1.2 1.2 0 0 0-.848.352 1.2 1.2 0 0 0 0 1.697l7.2 7.2a1.2 1.2 0 0 0 1.696 0 1.2 1.2 0 0 0 0-1.698L10.45 8.752A1.2 1.2 0 0 0 9.6 8.4"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;
